// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ShowWaterfallSummaryTileDetailsQueryVariables = Types.Exact<{
  waterfallSummaryTileDetailsWhereInput?: Types.InputMaybe<Types.WaterfallSummaryTileDetailsWhereInput>;
}>;


export type ShowWaterfallSummaryTileDetailsQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: { __typename?: 'EstateWaterfall', id: string, localShowSummaryTileDetails: boolean } | null } | null> | null } };

export const Operations = {
  Query: {
    ShowWaterfallSummaryTileDetails: 'ShowWaterfallSummaryTileDetails' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ShowWaterfallSummaryTileDetailsDocument = gql`
    query ShowWaterfallSummaryTileDetails($waterfallSummaryTileDetailsWhereInput: WaterfallSummaryTileDetailsWhereInput) {
  estateWaterfalls {
    edges {
      node {
        id
        localShowSummaryTileDetails(where: $waterfallSummaryTileDetailsWhereInput) @client
      }
    }
  }
}
    `;

/**
 * __useShowWaterfallSummaryTileDetailsQuery__
 *
 * To run a query within a React component, call `useShowWaterfallSummaryTileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowWaterfallSummaryTileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowWaterfallSummaryTileDetailsQuery({
 *   variables: {
 *      waterfallSummaryTileDetailsWhereInput: // value for 'waterfallSummaryTileDetailsWhereInput'
 *   },
 * });
 */
export function useShowWaterfallSummaryTileDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>(ShowWaterfallSummaryTileDetailsDocument, withFetchPolicyContext(options));
      }
export function useShowWaterfallSummaryTileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>(ShowWaterfallSummaryTileDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useShowWaterfallSummaryTileDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>(ShowWaterfallSummaryTileDetailsDocument, withFetchPolicyContext(options));
        }
export type ShowWaterfallSummaryTileDetailsQueryHookResult = ReturnType<typeof useShowWaterfallSummaryTileDetailsQuery>;
export type ShowWaterfallSummaryTileDetailsLazyQueryHookResult = ReturnType<typeof useShowWaterfallSummaryTileDetailsLazyQuery>;
export type ShowWaterfallSummaryTileDetailsSuspenseQueryHookResult = ReturnType<typeof useShowWaterfallSummaryTileDetailsSuspenseQuery>;
export type ShowWaterfallSummaryTileDetailsQueryResult = Apollo.QueryResult<ShowWaterfallSummaryTileDetailsQuery, ShowWaterfallSummaryTileDetailsQueryVariables>;